
    import {Component, Prop, Vue} from 'vue-property-decorator'
    import {GoodsListOfCategoryDto, GoodsListOfCategoryFormatDto} from "@/api/commonConfig";
    import {getGoodsSpecificationList, PackageListDto} from "@/api/buyCar";
    import {Getter} from "vuex-class";

    @Component({
        name: 'ChooseGoodsCard'
    })
    export default class ChooseGoodsCard extends Vue {
        @Prop({
            default: () => {
            }
        }) data!: GoodsListOfCategoryFormatDto
        @Prop({ default: '' }) customerId?: string
        @Prop({ default: true }) showDesc?: boolean
        @Getter companyId!: string

        packageList: PackageListDto[] = []

    }
